import { Injectable } from "@angular/core";
import { IID_ASSURANCE_TICKET } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDassuranceTicketStore } from "./iidAssuranceTicket.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.ASSURANCE_TICKET)
export class IIDassuranceTicketQuery extends AbstractInterfaceDataQuery<IID_ASSURANCE_TICKET> {

  constructor(protected store: IIDassuranceTicketStore) {
    super(store);
  }
}
